import axios from 'axios'

/**
 * @desc fetch list of all Agent Supplier Rules
 * @param {Integer} supplierId
 */
export const fetchAgentSupplierRules = (supplierId) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/agent-supplier-rules`)
    .then((res) => res.data)

/**
 * @desc create Agent Supplier Rule
 * @param {Object} payload
 */
export const createAgentSupplierRule = (payload) => {
  const { supplierId, updateData } = payload
  return axios
    .post(
      `/authenticated/supplier/${supplierId}/agent-supplier-rules`,
      updateData
    )
    .then((res) => res.data)
}

/**
 * @desc update Agent Supplier Rule
 * @param {Object} payload
 */
export const updateAgentSupplierRule = (payload) => {
  const { supplierId, agentSupplierRuleId, updateData } = payload
  return axios
    .put(
      `/authenticated/supplier/${supplierId}/agent-supplier-rules/${agentSupplierRuleId}`,
      updateData
    )
    .then((res) => res.data)
}

/**
 * @desc delete Agent Supplier Rule
 * @param {Object} payload
 */
export const deleteAgentSupplierRule = (payload) => {
  const { supplierId, agentSupplierRuleId } = payload
  return axios
    .delete(
      `/authenticated/supplier/${supplierId}/agent-supplier-rules/${agentSupplierRuleId}`
    )
    .then((res) => res.data)
}
